import { configureStore } from '@reduxjs/toolkit';
import notificationReducer from './slice/notificationSlice';
import authSlice from './slice/authSlice';

export default configureStore({
    reducer: {
        notification: notificationReducer,
        auth: authSlice
    }
})